import { ThemeT, FileUtils } from '@signavio/effektif-commons'
import { Icon, TextTile, useStyles } from '@signavio/ui'
import { File } from '../../../types'

type FileBaseProps = {
  showImage?: boolean
  small?: boolean
  transparent?: boolean
  src: string
  file: File
}

function FileBase({ showImage, small, transparent, file, src }: FileBaseProps) {
  const style = useStyles(defaultStyle, {})

  const { name, contentType, sizeInBytes } = file

  if (showImage && FileUtils.isImage(contentType)) {
    return (
      <a {...style} href={src} title={file.name} rel="external">
        <img {...style('image')} src={src} alt={name} title={name} />
      </a>
    )
  }

  return (
    <TextTile
      transparent={transparent}
      small={small}
      header={
        <div {...style('icon')}>
          <Icon icon={FileUtils.getIcon(name, contentType)} />
        </div>
      }
      subtitle={FileUtils.getReadableSize(sizeInBytes)}
    >
      <a href={src} title={file.name} rel="external">
        {name}
      </a>
    </TextTile>
  )
}

const defaultStyle = ({ padding }: ThemeT) => ({
  icon: {
    marginRight: -padding.normal,
  },

  image: {
    display: 'block',

    maxWidth: '100%',
  },
})

export default FileBase
